import script from "./return_asset_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./return_asset_btn.vue?vue&type=script&setup=true&lang=js"

import "./return_asset_btn.vue?vue&type=style&index=0&id=7052562a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7052562a"]])

export default __exports__